import { calendarSliceActions } from "./features/calendar";
import { campaignsSliceActions } from "./features/campaigns";
import { conversationsSliceActions } from "./features/conversations";
import { merchantSliceActions } from "./features/merchant";
import { messagesSliceActions } from "./features/messages";
import { onboardingSliceActions } from "./features/onboarding";
import { paymentsSliceActions } from "./features/payments";
import { templateSliceActions } from "./features/templates";

export const MERCHANT_SLICES = [
  templateSliceActions,
  conversationsSliceActions,
  calendarSliceActions,
  campaignsSliceActions,
  messagesSliceActions,
  onboardingSliceActions,
  paymentsSliceActions,
  merchantSliceActions,
];
